module.exports = __webpack_public_path__ + "img/gdnyzb_s.6a9b83a.png";